import gql from "graphql-tag";

export const CreateCampaign = gql`
  mutation CreateCampaign($input: CreateCampaignInput!) {
    createCampaign(input: $input) {
      campaignId
      accountId
      status
      subject
      dateCreated
      stats {
        dateSent
        sentCount
        openCount
        clickCount
      }
    }
  }
`;

export const TestSendCampaign = gql`
  mutation TestSendCampaign($input: TestSendCampaignInput!) {
    testSendCampaign(input: $input) {
      sent
      email
    }
  }
`;

export const SendCampaign = gql`
  mutation SendCampaign($input: SendCampaignInput!) {
    sendCampaign(input: $input) {
      sent
    }
  }
`;

export const UpdateCampaign = gql`
  mutation UpdateCampaign($input: UpdateCampaignInput!) {
    updateCampaign(input: $input) {
      campaignId
      accountId
      status
      subject
      dateCreated
      stats {
        dateSent
        sentCount
        openCount
        clickCount
      }
    }
  }
`;

export const UpdateCampaignSubject = gql`
  mutation UpdateCampaign($input: UpdateCampaignInput!) {
    updateCampaign(input: $input) {
      campaignId
      subject
    }
  }
`;

export const UpdateBrand = gql`
  mutation UpdateBrand($input: UpdateBrandInput!) {
    updateBrand(input: $input) {
      logoImageUrl
      primaryColor
      secondaryColor
    }
  }
`;

export const ReorderSections = gql`
  mutation ReorderSections($input: ReorderSectionsInput!) {
    reorderSections(input: $input) {
      campaignId
      accountId
      template {
        sections {
          sectionId
          order
          name
          widgetId
          locked
        }
      }
    }
  }
`;

export const AddSectionToCampaign = gql`
  mutation AddSectionToCampaign($input: AddSectionToCampaignInput!) {
    addSectionToCampaign(input: $input) {
      campaignId
      accountId
      template {
        sections {
          sectionId
          order
          name
          widgetId
          locked
        }
      }
    }
  }
`;

export const OnBoarding = gql`
  mutation OnBoarding($input: OnBoardingInput!) {
    onBoarding(input: $input) {
      onboardingComplete
    }
  }
`;

export const UpdateSectionSettings = gql`
  mutation UpdateSectionSettings($input: UpdateSectionSettingsInput!) {
    updateSectionSettings(input: $input) {
      sectionId
      order
      name
      widgetId
      locked
      settings {
        id
        label
        message
        ... on BooleanSetting {
          valueField
          booleanValue
        }
        ... on ColorSetting {
          valueField
          colorValue
        }
        ... on FileSetting {
          valueField
          fileValue
        }
        ... on NumberSetting {
          valueField
          numberValue
          min
          max
        }
        ... on TextSetting {
          valueField
          textValue
          multiline
          maxLength
          default
        }
        ... on SelectorSetting {
          valueField
          selectorValue
          items {
            label
            value
          }
        }
        ... on ElementSetting {
          valueField
          elementValue
          id
          selectedElement {
            category {
              label
              description
            }
            elementId
            asset {
              ... on ImageAssetType {
                image {
                  alt
                  src
                }
              }
            }
            previewImage {
              alt
              src
            }
            price
            tags {
              value
            }
            name
            type {
              elementTypeId
              label
            }
          }
          label
          message
          valueField
          elementTypes {
            elementTypeId
            label
          }
        }
      }
    }
  }
`;

export const RemoveSectionFromCampaign = gql`
  mutation RemoveSectionFromCampaign($input: RemoveSectionFromCampaignInput!) {
    removeSectionFromCampaign(input: $input) {
      campaignId
      template {
        sections {
          sectionId
          order
          name
          widgetId
          locked
        }
      }
    }
  }
`;

export const UpdateCampaignFields = gql`
  mutation UpdateCampaignFields($input: UpdateCampaignFieldsInput!) {
    updateCampaignFields(input: $input) {
      campaignId
      subject
      fields {
        id
        label
        valueField
        ... on BooleanSetting {
          booleanValue
        }
        ... on ColorSetting {
          colorValue
        }
        ... on FileSetting {
          fileValue
        }
        ... on NumberSetting {
          numberValue
          min
          max
        }
        ... on TextSetting {
          textValue
          multiline
          maxLength
          default
        }
        ... on SelectorSetting {
          selectorValue
          items {
            label
            value
          }
        }
        ... on ElementSetting {
          elementValue
          selectedElement {
            category {
              label
              description
            }
            elementId
            asset {
              ... on ImageAssetType {
                image {
                  alt
                  src
                }
              }
            }
            previewImage {
              alt
              src
            }
            price
            tags {
              value
            }
            name
            type {
              elementTypeId
              label
            }
          }
          id
          label
          message
          valueField
          elementTypes {
            elementTypeId
            label
          }
        }
      }
    }
  }
`;

export const DownloadCampaign = gql`
  mutation DownloadCampaign($input: DownloadCampaignInput!) {
    downloadCampaign(input: $input) {
      downloadUrl
    }
  }
`;

export const RemoveCampaign = gql`
  mutation RemoveCampaign($input: RemoveCampaignInput!) {
    removeCampaign(input: $input) {
      campaignId
    }
  }
`;

export const CreateImageElement = gql`
  mutation CreateImageElement($input: CreateImageElementInput!) {
    createImageElement(input: $input) {
      elementId
      name
      type {
        elementTypeId
        description
      }
      category {
        categoryId
        label
      }
      asset {
        ... on ImageAssetType {
          image {
            alt
            src
          }
        }
      }
      description
      previewImage {
        src
        alt
      }
      price
      tags {
        value
      }
    }
  }
`;

export const CreateBaseTemplate = gql`
  mutation CreateBaseTemplate($input: CreateBaseTemplateInput!) {
    createBaseTemplate(input: $input) {
      baseTemplateId
      name
      description
      previewImage {
        src
        alt
      }
      category {
        categoryId
        description
      }
      type {
        label
        description
      }
      price
    }
  }
`;
